import type { Locale } from "@/i18n/config";
import type { ReactElement } from "react";

// Inline SVG flags — no assets, and reliable on Windows (unlike flag emoji).
// The star uses the ★ glyph so we avoid hand-plotting a 5-point path.

type FlagProps = { className?: string };

function FlagTR({ className }: FlagProps) {
    return (
        <svg
            viewBox="0 0 30 20"
            preserveAspectRatio="xMidYMid slice"
            className={className}
            aria-hidden="true"
        >
            <rect width="30" height="20" rx="2.5" fill="#E30A17" />
            <circle cx="11.5" cy="10" r="4.6" fill="#fff" />
            <circle cx="13" cy="10" r="3.7" fill="#E30A17" />
            <text
                x="18"
                y="10"
                fontSize="8"
                fill="#fff"
                textAnchor="middle"
                dominantBaseline="central"
            >
                ★
            </text>
        </svg>
    );
}

function FlagAZ({ className }: FlagProps) {
    return (
        <svg
            viewBox="0 0 30 20"
            preserveAspectRatio="xMidYMid slice"
            className={className}
            aria-hidden="true"
        >
            <defs>
                <clipPath id="flag-az-rounded">
                    <rect width="30" height="20" rx="2.5" />
                </clipPath>
            </defs>
            <g clipPath="url(#flag-az-rounded)">
                <rect width="30" height="6.667" fill="#0092BC" />
                <rect width="30" height="6.667" y="6.667" fill="#E4002B" />
                <rect width="30" height="6.667" y="13.333" fill="#00AF66" />
                <circle cx="13" cy="10" r="3.1" fill="#fff" />
                <circle cx="14.3" cy="10" r="2.5" fill="#E4002B" />
                <text
                    x="17.6"
                    y="10"
                    fontSize="5.2"
                    fill="#fff"
                    textAnchor="middle"
                    dominantBaseline="central"
                >
                    ★
                </text>
            </g>
        </svg>
    );
}

export const localeFlags: Record<Locale, (props: FlagProps) => ReactElement> = {
    tr: FlagTR,
    az: FlagAZ,
};
